// src/constants/products.js

const VL02SIZES = [
  { name: "1 inch", code: "01", height: 1, charPrice: 1.55 },
  { name: "2 inch", code: "02", height: 2, charPrice: 1.55 },
  { name: "3 inch", code: "03", height: 3, charPrice: 1.89 },
  { name: "4 inch", code: "04", height: 4, charPrice: 2.0 },
  { name: "5 inch", code: "05", height: 5, charPrice: 2.65 },
  { name: "6 inch", code: "06", height: 6, charPrice: 3.0 },
  { name: "7 inch", code: "07", height: 7, charPrice: 3.42 },
  { name: "8 inch", code: "08", height: 8, charPrice: 3.9 },
  { name: "9 inch", code: "09", height: 9, charPrice: 4.72 },
  { name: "10 inch", code: "10", height: 10, charPrice: 5.35 },
  { name: "11 inch", code: "11", height: 11, charPrice: 6.25 },
  { name: "12 inch", code: "12", height: 12, charPrice: 7.15 },
];

const VL03SIZES = [
  { name: "1 inch", code: "01", height: 1, charPrice: 2.45 },
  { name: "2 inch", code: "02", height: 2, charPrice: 2.45 },
  { name: "3 inch", code: "03", height: 3, charPrice: 3.1 },
  { name: "4 inch", code: "04", height: 4, charPrice: 4.22 },
  { name: "5 inch", code: "05", height: 5, charPrice: 5.46 },
  { name: "6 inch", code: "06", height: 6, charPrice: 6.99 },
  { name: "7 inch", code: "07", height: 7, charPrice: 8.72 },
  { name: "8 inch", code: "08", height: 8, charPrice: 10.92 },
  { name: "9 inch", code: "09", height: 9, charPrice: 13.09 },
  { name: "10 inch", code: "10", height: 10, charPrice: 15.82 },
  { name: "11 inch", code: "11", height: 11, charPrice: 18.47 },
  { name: "12 inch", code: "12", height: 12, charPrice: 20.17 },
];

export const PRODUCTS = [
  {
    code: "VL0200",
    defaultSize: "02",
    defaultColor: "black_190",
    header: "VINYL LETTERING CUSTOM DECALS",
    headerText:
      "Vinyl lettering and numbers are utilized for business signs, boat lettering, car lettering, home decor wall lettering, and more. The sign designer allows you to customize the most popular fonts and colors, calculate dimensions, and instantly view the prices. Decals include instructions and squeegee. You can add up to three lines at a time.",
    breadcrumbs: [
      {
        name: "Vinyl Lettering",
        href: "https://www.alphabetsigns.com/signs/vinyl-lettering.html",
      },
    ],
    sizes: VL02SIZES,
    scaleFactor: 72,
    product_attributes: {
      phrase: { type: "text", required: true },
      color: { type: "select", required: true, code: "Color", options: [] },
      size: { type: "select", required: true, options: VL02SIZES },
      font: { type: "select", required: true, code: "Font", options: [] },
    },
  },
  {
    code: "VL0300",
    defaultSize: "02",
    defaultColor: "White_7801",
    header: "REFLECTIVE VINYL LETTERS",
    headerText:
      "Reflective vinyl letters & numbers are made from Engineer Grade reflectivity and are used for emergency vehicles, security, truck letters, traffic signs and nighttime visible lettering. Design your reflective vinyl lettering online and instantly view all fonts & colors, calculate dimensions and prices. Customize fonts and colors, calculate dimensions, and view prices instantly with our sign designer. Decals include instructions and squeegee. Add up to three lines at a time.",
    breadcrumbs: [
      {
        name: "Vinyl Lettering",
        href: "https://www.alphabetsigns.com/signs/vinyl-lettering.html",
      },
      {
        name: "Reflective Vinyl Lettering",
        href: "https://www.alphabetsigns.com/signs/reflective-vinyl-sign-letters.html",
      },
    ],
    sizes: VL03SIZES,
    scaleFactor: 72,
    product_attributes: {
      phrase: { type: "text", required: true },
      color: { type: "select", required: true, code: "Color", options: [] },
      size: { type: "select", required: true, options: VL03SIZES },
      font: { type: "select", required: true, code: "Font", options: [] },
    },
  },
];

export const getProductByCode = (productCode) => {
  return PRODUCTS.find((p) => p.code === productCode) || null;
};
